import { ThemeSpecification } from '@neutrino/theme-compiler';
import { baseTheme } from '@neutrino/theming';

const PRIMARY: [number, number, number] = [34, 84, 118];
const SECONDARY: [number, number, number] = [118, 34, 84];
const TERTIARY = PRIMARY.map(v => v * 1.75) as [number, number, number];

export const leaderboardTheme: ThemeSpecification = {
    name: 'leaderboard',
    baseTheme: baseTheme,
    header: {
        base: PRIMARY
    },
    selected: {
        base: PRIMARY
    },
    callToAction: {
        base: SECONDARY
    },
    accent: {
        base: TERTIARY
    },

    informativeSeverityLow: {
        base: PRIMARY
    },
    informativeSeverityCritical: {
        base: SECONDARY
    },
    icon: {
        red: SECONDARY,
        blue: PRIMARY
    },
    misc: {
        controlError: SECONDARY
    },
    chartColors: [
        '#003f5c',
        '#ffa600',
        '#a05195',
        '#ff7c43',
        '#2f4b7c',
        '#665191',
        '#d45087',
        '#f95d6a'
    ],
    override: {
        'nav-active-informative-severity-low': args => args.background.level0,
        'nav-on-active-informative-severity-low': PRIMARY
    }
};
